import moment from 'moment-timezone';

import { User } from '@/utils/interfaces/User';

const FORMAT_TYPES: Record<string, string> = {
  default: 'Do MMMM, YYYY, h:mm A',
  dateOnly: 'Do MMM, YYYY',
  short: 'DD-MM-YYYY',
  long: 'dddd, Do MMMM YYYY, h:mm:ss A',
  iso: 'YYYY-MM-DDTHH:mm:ssZ',
};

export const formatDateByCountry = (
  dateString: string,
  userData: User | undefined,
  formatType: keyof typeof FORMAT_TYPES | string = 'default',
): string => {
  if (!dateString) return '';

  const userTimeZone = userData?.user_attributes?.find(
    (item) => item.attribute_key === 'time_zone',
  )?.attribute_value;

  const timeZone = userTimeZone ?? 'Asia/Kolkata';

  const date = moment.utc(dateString).tz(timeZone as string);

  const tzAbbr = date.format('z');

  const formatPattern =
    FORMAT_TYPES[formatType] || (formatType as string) || FORMAT_TYPES.default;

  return `${date.format(formatPattern)} (${tzAbbr})`;
};
